import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=e7399da0"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default,SupportTicketButton: require('/vercel/path0/components/partials/support_ticket/SupportTicketButton.vue').default,Currencies: require('/vercel/path0/components/partials/Currencies.vue').default,Locales: require('/vercel/path0/components/partials/Locales.vue').default,Login: require('/vercel/path0/components/partials/Login.vue').default,ColorModeToggle: require('/vercel/path0/components/partials/ColorModeToggle.vue').default})
